import { numberSeparator } from "@/hooks/useThousandsSeparator";
import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Grid } from "@mui/material";
/**
Content

کامپوننتی برای نمایش کارت‌های آماری مربوط به هدیه‌ها.
ویژگی‌ها:
نمایش چهار کارت با اطلاعات مختلف از لیست listIncreaseGift.
هر کارت شامل:
عنوان کارت
مبلغ مربوطه (ریال) با فرمت هزارگان
محتوا اضافی (مثلاً لینک جزئیات کاربر برای کارت چهارم)
استفاده از Grid از MUI برای چیدمان ریسپانسیو:
xs: 12 → کارت‌ها در موبایل تمام عرض هستند
sm: 6 → دو کارت در هر ردیف در صفحه‌های کوچک
md: 3 → چهار کارت در هر ردیف در صفحه‌های متوسط و بزرگ
استفاده از StackKit و CardKit برای چینش و استایل کارت‌ها.
استایل ریسپانسیو برای padding و سایز فونت:
padding کارت‌ها: xs = 16px، sm = 20px
fontSize عنوان: xs = 0.875rem، sm = 1rem
fontSize مبلغ: xs = 1rem، sm = 1.25rem
کارت چهارم دارای محتوا اضافی شامل نام کاربری و لینک مشاهده جزئیات با استایل قابل کلیک.
@param {Object} props
@param {Array} props.listIncreaseGift - آرایه شامل اطلاعات هدیه‌ها برای پر کردن کارت‌ها.
@returns JSX.Element
*/
const Content = ({ listIncreaseGift }: { listIncreaseGift: any }) => {

  const cardsDetail = [
    {
      title: "موجودی هدیه قابل استفاده شما",
      amount: `${numberSeparator(listIncreaseGift[0]?.price)} ریال`,
      content: "",
    },
    {
      title: "مجموع هدیه های داده شده تا این لحظه",
      amount: `${numberSeparator(listIncreaseGift[1]?.price)} ریال`,
      content: "",
    },
    {
      title: "مجموع هدیه های طرح شده تا این لحظه",
      amount: `${numberSeparator(listIncreaseGift[2]?.price)} ریال`,
      content: "",
    },
    {
      title: "بیشترین هدیه تخصیص یافته تا کنون",
      amount: `${numberSeparator(listIncreaseGift[3]?.price)} ریال`,
      content: (
        <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"start"}>
          <TypoGraphyKit variant="body1">نام کاربری:</TypoGraphyKit>
          <TypoGraphyKit variant="body1" sx={{color: "#32ADE6",textDecoration: "#32ADE6",borderBottom: "1px solid #32ADE6",cursor: "pointer",}} >
            مشاهده جزئیات کاربر
          </TypoGraphyKit>
        </StackKit>
      ),
    },
  ];

  return (
    <Grid container spacing={2} sx={{height:{sm:'auto',md:'100%'}}}>
      {cardsDetail.map((item, index) => (
        <Grid key={index} size={{xs:12,sm:6,md:3}} sx={{height:'100%'}}>
          <CardKit sx={{bgcolor: "#434343",height: "100%",borderRadius: "24px",display: "flex",flexDirection: "column",justifyContent: "center",padding: { xs: "16px", sm: "20px" },}}>
            <StackKit sx={{ width: "100%", height: "100%" }} justifyContent={"center"}>
              <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                {item.title}
              </TypoGraphyKit>
              <StackKit sx={{ width: "100%", minHeight: "137px", justifyContent: "center", alignContent: "center", mt: 1 }}>
                <TypoGraphyKit variant="subtitle1" sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}>
                  {item.amount}
                </TypoGraphyKit>
                {item.content}
              </StackKit>
            </StackKit>
          </CardKit>
        </Grid>
      ))}
    </Grid>
  );
};

export default Content;
